import React from 'react';
import './ReviewerPage.css';

const ReviewerPage = () => {
  return (
    <div className="reviewer-page">
      <div className="reviewer-container">

        {/* 헤더 섹션 */}
        <div className="reviewer-header">
          <h1 className="main-title">Nexpa LIDIA</h1>
          <h2 className="sub-title">문해력 평가 문항<br/>리뷰어 모집</h2>
          <p className="description">
            AI기반 독서 평가 플랫폼 Nexpa LIDIA는<br/>
            독서 기반 문해력 평가 콘텐츠의 정확성과 교육적<br/>
            완성도를 높이기 위해 전문 리뷰어를 모집합니다
          </p>
        </div>

        {/* 콘텐츠 섹션 */}
        <div className="reviewer-content">
          <div className="content-grid">
            <div className="content-section">
              <h3><span className="check-icon">✓</span> 주요 역할</h3>
              <ul>
                <li>자동생성문항(객관식/주관식) 검토</li>
                <li>문해력 요소 반영 여부 및 내용 타당성 확인</li>
                <li>문제 유형 분류 및 개선 피드백 제안</li>
              </ul>
            </div>

            <div className="content-section">
              <h3><span className="check-icon">✓</span> 자격 요건</h3>
              <ul>
                <li>국어, 독서, 논술 교육 경력자</li>
                <li>문해력 평가 문항 출제 또는 검토 경험</li>
              </ul>
            </div>
          </div>

          <div className="content-section single">
            <h3><span className="check-icon">✓</span> 지원 방법</h3>
            <ul>
              <li>제출: 이력서 및 관련 경험 요약(자유 양식)</li>
              <li>접수: review@lidia.ai</li>
            </ul>
          </div>
        </div>

        {/* 하단 CTA 섹션 */}
        <div className="reviewer-cta">
          <div className="cta-content">
            <p className="cta-text">
              학생의 '이해하는 힘'을 정밀하게 측정하는 AI<br/>
              독서 평가 기준을 함께 설계해 나갈 전문가<br/>
              여러분의 참여를 기다립니다
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewerPage; 